// extracted by mini-css-extract-plugin
module.exports = {"text":"ConfirmNextPageModal_text__1z_G3"};